import {
  Card,
  CardContent,
  CardHeader,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui";
import { BadgeInfo, Search } from "lucide-react";
import useApprovalLimits from "./useApprovalLimits";
import { DataTable, FormLabel, Loader } from "@/components";
import { cn } from "@/lib/utils";

const ApprovalLimits = () => {
  const {
    globalFilter,
    setGlobalFilter,
    columns,
    positionApprovalLimits,
    year,
    onYearChange,
    isCommunityLimitLoading,
    approvalLimits,
    isBudgetYearLoading,
    yearOptions,
  } = useApprovalLimits();

  return (
    <div className="flex flex-col gap-5 mt-4">
      <div className="flex flex-row items-end justify-end gap-4">
        <Input
          type="text"
          placeholder="Search"
          value={globalFilter ?? ""}
          onChange={(e) => setGlobalFilter(e.target.value)}
          className="w-full sm:w-72 bg-white h-[40px]"
          startIcon={<Search className="w-4 h-4" />}
        />
        {isBudgetYearLoading ? (
          <></>
        ) : (
          <div className="flex items-center gap-2">
            {!yearOptions?.length ? (
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger className="mx-1" type="button">
                    <BadgeInfo className="h-5 w-5 stroke-yellow-600" />
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>You need to set the budget first.</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            ) : (
              <></>
            )}
            <div className="relative">
              <FormLabel>Year</FormLabel>
              <Select onValueChange={onYearChange}>
                <SelectTrigger
                  className={cn(
                    "w-full bg-white",
                    !yearOptions?.length ? "w-[100px]" : ""
                  )}
                  disabled={!yearOptions?.length}
                >
                  <SelectValue
                    placeholder={
                      yearOptions?.find((data: any) => data.value == year)
                        ?.label
                    }
                  />
                </SelectTrigger>
                <SelectContent>
                  {yearOptions?.map((data: any) => (
                    <SelectItem key={data?.value} value={data?.value}>
                      {data?.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>
        )}
      </div>

      <>
      {isCommunityLimitLoading ? (
        <Loader />
      ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[20px]">
            {approvalLimits?.map((data: any) => (
              <Card key={data?.title}>
                <CardContent>
                  <CardHeader className="text-primary font-[600] m-0 p-0 mb-3">
                    {data?.title}
                  </CardHeader>
                  <div className="grid grid-cols-2 text-[14px] gap-1">
                    {data?.data?.map((val: any) => (
                      <>
                        <span className="font-[500] text-g-500">
                          {val?.label}
                        </span>
                        <span>: {val?.value}</span>
                      </>
                    ))}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
      )}
       <DataTable
          columns={columns}
          data={positionApprovalLimits || []}
          setGlobalFilter={setGlobalFilter}
          globalFilter={globalFilter}
        />
      </>
    </div>
  );
};

export default ApprovalLimits;
